export default "skymp5-front/95ef521334d6e74aca76d7ef28fd11a7.svg";